var NDJSON = function () {
  function NDJSON() {}

  NDJSON.stringify = function stringify(object) {
    return JSON.stringify(object) + '\n';
  };

  return NDJSON;
}();

export default NDJSON;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@elastic/apm-rum-core/dist/es/common/ndjson.js
// module id = 2499
// module chunks = 0